

import { IState } from '../../core/IState';
import { RulesController } from './rulesController';
import '../rules/rulesService';
import '../navigation/navigationController';
import '../rules/directives/rulesDirective';
import '../navigation/navigationService';

export const rulesState : IState = {
    name: 'rules',
    url: '/rules',
    parent: 'root',
    template: require('./rules.html'),
    controller: RulesController,
    controllerAs: 'vm',
    data: {
        title: 'Rules',
        requiredFeature: 'Rules'
    }
}

angular.module('deliveryCreate.app').config([
    '$stateProvider', ($stateProvider: angular.ui.IStateProvider) => {
        $stateProvider.state(rulesState);
    }
]);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/rules/rulesState.ts
 **/